export const MaybeFaireDirectBrandBannerImage: React.FC<{
  bannerImageSrc: string | undefined;
}> = ({ bannerImageSrc }) => {
  if (!bannerImageSrc) {
    return null;
  }

  return (
    <div className="h-full w-full md:h-[120px]">
      <img className="h-full w-full object-cover" src={bannerImageSrc} alt="" />
    </div>
  );
};
